import React from 'react'
import facebook from './svgs/Diploma.svg'
import { BaseIcon } from './_base'

export const DiplomaIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {facebook} {...{fontSize,size,...sx}} />
    )
}
